import { useSelector } from 'react-redux';
import { randomGameIdSelector } from '../redux/reducers/app/configuration';
import * as ROUTE_TEMPLATES from '../constants/routeTemplates';

export const useRandomGameRoute = () => {
  const randomGameId = useSelector(randomGameIdSelector);

  return ROUTE_TEMPLATES.GAME_DETAIL.replace(':gameId', randomGameId);
};
